// Configuración leída de las variables de Vite (ver .env.example).
const env = import.meta.env;

const limpiar = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

export type ModoAuth = 'entra' | 'dev';

export const config = {
  modoAuth: (limpiar(env.VITE_AUTH_MODE) === 'dev' ? 'dev' : 'entra') as ModoAuth,
  apiUrl: limpiar(env.VITE_API_URL).replace(/\/+$/, ''),
  entra: {
    tenantId: limpiar(env.VITE_ENTRA_TENANT_ID),
    clientId: limpiar(env.VITE_ENTRA_CLIENT_ID),
    apiScope: limpiar(env.VITE_API_SCOPE),
    redirectUri: limpiar(env.VITE_ENTRA_REDIRECT_URI) || window.location.origin,
  },
};

/** Datos simulados en el navegador: solo en modo dev y sin URL de API. */
export const usaMock = config.modoAuth === 'dev' && config.apiUrl === '';
